// extracted by mini-css-extract-plugin
module.exports = {"bottomGradient":"bottomGradient_bottomGradient__2wb4D","welcomeGradient":"bottomGradient_welcomeGradient__2zJEG"};